<template>
  <div
    class="main-div"
  >
    {{ config.text || '' }}
  </div>
</template>

<script>
export default {
  name: 'InfoTooltipContent',

  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
.main-div {
  background-color: #F3F4F6 !important; /* light gray background */
  color: #111827 !important; /* dark text */
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  border-radius: 8px !important;
  border: 1px solid #D1D5DB !important;
  padding: 8px 12px !important;
  box-shadow: none !important; /* remove default dark shadow */
  max-width: 250px; /* optional: control wrapping */
  white-space: normal; /* allow text to wrap */
  text-align: left; /* align text like in your screenshot */
}
</style>
